import { useNavigate } from "react-router-dom";
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import DynamicCardRow from "../../DynamicCardRow/DynamicCardRow";
import ActionButton from "../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import BlueTableHeading from "../../../common/AdminCommonComponents/BlueTableHeading/BlueTableHeading";
import GrayDivider from "../../../common/AdminCommonComponents/GrayDivider/GrayDivider";

const Returns = () => {

  const navigate = useNavigate()

  const actions = [
    { label: 'View', action: () => navigate('/fbm-management/view-return-order-detail') }
  ]

  const orders = [
    { title: "TOTAL RETURNED PRODUCTS", value: 0 },
    { title: "RESTOCKED", value: 0 },
  ];

  const tableData = [
    { sr: '1', returnId: 'R-1001', orderId: 'ORD-1001', warehouse: 'ABC Logistics', returnStatus: 'Pending', restocked: 'Yes', processedDate: '01-12-2024' },
    { sr: '2', returnId: 'R-1001', orderId: 'ORD-1001', warehouse: 'global warehouse', returnStatus: 'Pending', restocked: 'No', processedDate: '01-12-2024' },
    { sr: '3', returnId: 'R-1001', orderId: 'ORD-1001', warehouse: 'ABC Logistics', returnStatus: 'Pending', restocked: 'Yes', processedDate: '01-12-2024' },
    { sr: '4', returnId: 'R-1001', orderId: 'ORD-1001', warehouse: 'global warehouse', returnStatus: 'Pending', restocked: 'No', processedDate: '01-12-2024' },
    { sr: '5', returnId: 'R-1001', orderId: 'ORD-1001', warehouse: 'ABC Logistics', returnStatus: 'Pending', restocked: 'Yes', processedDate: '01-12-2024' },
  ]

  const columns = [
    { name: 'Sr', selector: (row) => row.sr, grow: 0.5 },
    { name: 'Return ID', selector: (row) => row.returnId, grow: 0.5 },
    { name: 'Order ID', selector: (row) => row.orderId },
    { name: 'Warehouse', selector: (row) => row.warehouse },
    { name: 'Return Status', selector: (row) => row.returnStatus },
    { name: 'Restocked?', selector: (row) => row.restocked },
    { name: 'Processed Date', selector: (row) => row.processedDate },
    { name: 'Action', cell: () => <ActionButton options={actions} /> },
  ]

  return (
    <div>
      <div className="bg-white mt-3 shadow py-3 px-4">
        <div class="fw-semibold fs-5 mb-3">Overview</div>
        <DynamicCardRow cards={orders} />
      </div>

      <div className="bg-white shadow mt-3">
        <BlueTableHeading className='px-4 py-3 fw-semibold fs-5'>Return Management</BlueTableHeading>
        <GrayDivider />
        <div className="p-3">
          <DynamicDatatable data={tableData} columns={columns} type='gray' pagination />
        </div>
      </div>
    </div>
  );
};

export default Returns;